import React from 'react';
import { COMPONENT_TYPES } from '../../../constants';
import DualBannerEditor from '../../DualBanner/DualBanner.editor';
import DualBannerProperties from './DualBanner.properties';
import { registerComponent } from '../registry';
import { DualBannerComponent } from '../../DualBanner';

// 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.DUAL_BANNER,
  component: DualBannerComponent,
  editorComponent: DualBannerEditor,
  properties: DualBannerProperties,
  defaultProps: {
    componentProps: {
      images: [
        {
          imageUrl: 'https://via.placeholder.com/600x400/333/fff?text=Banner+1',
          linkUrl: '',
          linkTarget: '_self',
          altText: '배너 이미지 1'
        },
        {
          imageUrl: 'https://via.placeholder.com/600x400/666/fff?text=Banner+2',
          linkUrl: '',
          linkTarget: '_self',
          altText: '배너 이미지 2'
        }
      ],
      leftContent: '<h2>왼쪽 배너 텍스트</h2><p>여기에 내용을 추가하세요.</p>',
      rightContent: '<h2>오른쪽 배너 텍스트</h2><p>여기에 내용을 추가하세요.</p>',
      overlayColor: '#000000',
      overlayOpacity: 0.3,
      textColor: '#ffffff',
      height: 400,
      gap: 10
    },
    style: {
      width: '100%',
      margin: '0 auto',
      boxSizing: 'border-box'
    }
  },
  category: 'content',
  icon: '🎭',
  name: '듀얼 배너'
});

// 컴포넌트 및 타입 내보내기
export { DualBannerComponent } from '../../DualBanner';
export { default as DualBannerEditor } from '../../DualBanner/DualBanner.editor';
export { default as DualBannerProperties } from './DualBanner.properties';
export * from '../../DualBanner/DualBanner.types';